module.exports = __webpack_public_path__ + "img/juliette-ferland.985862f5.png";